module.exports = __webpack_public_path__ + "static/media/BG_27.fc0d56a4.png";